import { render } from "./right_r_bar.vue?vue&type=template&id=51b7d7ea"
import script from "./right_r_bar.vue?vue&type=script&lang=js"
export * from "./right_r_bar.vue?vue&type=script&lang=js"
script.render = render

export default script